import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default class UserListHeader extends React.Component {
  static propTypes = {
    selectedUsers: ImmutablePropTypes.map.isRequired,
    usersChoice: ImmutablePropTypes.map,
    onSelectAll: PropTypes.func.isRequired,
    onUnselectAll: PropTypes.func.isRequired,
    selectable: PropTypes.bool.isRequired,
  };

  render() {
    const {
      selectedUsers,
      usersChoice,
      selectable,
      onSelectAll,
      onUnselectAll,
    } = this.props;

    let count = 0;
    if (selectable) {
      count = selectedUsers.size;
    } else {
      count = usersChoice.size;
    }

    return (
      <div className="ui segment">
        <div className="header" style={{ overflow: 'hidden' }}>
          Destinataires:
          <em> {count} sélectionné(s)</em>
          <span className="action">
            {selectable && (
              <div className="ui buttons">
                <button onClick={onUnselectAll} className="ui button">
                  Aucun
                </button>
                <div className="or" data-text="ou" />
                <button onClick={onSelectAll} className="ui button">
                  Tous
                </button>
              </div>
            )}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/UserListHeader.js